import { Dialog, DialogActions, DialogContent, Button, Typography } from '@mui/material';

import { SAVE_BUTTON_TEXT, CANCEL_BUTTON_TEXT } from '../touchpoint.constants';

export type SyncInfoDialogProps = {
  open: boolean;
  onClose: () => void;
  message: string;
  onConfirm?: () => void;
};

export const SyncInfoDialog = ({ open, onClose, message, onConfirm }: SyncInfoDialogProps) => {
  const isConfirmation = Boolean(onConfirm);

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm'>
      <DialogContent sx={{ mb: 0, pb: 0 }}>
        <Typography variant='body1' sx={{ whiteSpace: 'pre-line' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions>
        {isConfirmation ? (
          <>
            <Button variant='text' color='primary' onClick={onClose}>
              {CANCEL_BUTTON_TEXT}
            </Button>
            <Button variant='contained' color='primary' onClick={onConfirm}>
              {SAVE_BUTTON_TEXT}
            </Button>
          </>
        ) : (
          <Button variant='contained' color='primary' onClick={onClose}>
            Ok
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
